import { ConfigProvider } from 'antd';
import styled from 'styled-components';
import { Tabs as AntdTabs, TabsProps } from 'antd';
import { Colors } from '../../constants';

const Tabs = ({ ...props }: TabsProps) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Tabs: {
            colorPrimary: Colors.secondary[5],
            horizontalItemGutter: 0,
            horizontalItemPadding: '20px 32px 16px',
            itemColor: Colors.neutral.text[6],
            fontSize: 18,
            fontFamily: 'Poppins',
            itemHoverColor: Colors.neutral.text[6],
            horizontalMargin: '0',
          },
        },
      }}
    >
      <StyledTabs {...props} />
    </ConfigProvider>
  );
};

export default Tabs;

const StyledTabs = styled(AntdTabs)`
  .ant-tabs-tab-btn {
    font-weight: 500;
  }

  .ant-tabs-tab {
    flex: 1;
    justify-content: center;
  }
`;
